import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { ChangeOrderDTO } from '../models/change-order-dto';
import { PuntoapuntoLocalCampaignFilter, RenaultPuntoapuntoLocalCampaignCardDTO, RenaultPuntoapuntoLocalCampaignDTO } from '../models/renault-puntoapunto-local-campaign';
import { PuntoapuntoLocalCampaignEmailStatisticsModel, PuntoapuntoLocalCampaignEmailStatisticsTable, PuntoapuntoLocalCampaignOrderDataStatisticsModel, PuntoapuntoLocalCampaignOrderDataStatisticsTimechartModel, PuntoapuntoLocalCampaignRequestOrder, RenaultPuntoapuntoLocalCampaignOrderDTO, RenaultPuntoapuntoLocalCampaignOrderListFilterDTO, RenaultPuntoapuntoLocalCampaignOrderSendTestDTO, RenaultPuntoapuntoLocalCampaignOrderStatisticsDTO } from '../models/renault-puntoapunto-local-campaign-order';
import { Select2Data } from 'ng-select2-component';
import { LocalCampaignMediaStatisticsFilters, LocalCampaignOrderDataStatisticsModel } from '../models/renault-local-campaign-order-dto';
import Swal from 'sweetalert2';
import * as html2pdf from 'html2pdf.js';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})

export class PuntoapuntoLocalCampaignOrderService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultPuntoapuntoLocalCampaignOrder/";

  constructor(private http: HttpClient) { }

  public initializeOrder(data: RenaultPuntoapuntoLocalCampaignOrderDTO): Observable<RenaultPuntoapuntoLocalCampaignOrderDTO> {
    return this.http.post<RenaultPuntoapuntoLocalCampaignOrderDTO>(this.pathAPI + this.controller + "InitializeOrder", data);
  }

  public initializeOrderData(data: PuntoapuntoLocalCampaignRequestOrder): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "InitializeOrderData", data);
  }

  public DuplicateOrder(IdOrder: string): Observable<RenaultPuntoapuntoLocalCampaignOrderDTO> {
    return this.http.post<RenaultPuntoapuntoLocalCampaignOrderDTO>(this.pathAPI + this.controller + "DuplicateOrder/" + IdOrder, null);
  }

  public get(id: string): Observable<RenaultPuntoapuntoLocalCampaignOrderDTO> {
    return this.http.get<RenaultPuntoapuntoLocalCampaignOrderDTO>(this.pathAPI + this.controller + id);
  }

  public put(id: string, data: RenaultPuntoapuntoLocalCampaignOrderDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public sendTest(data: RenaultPuntoapuntoLocalCampaignOrderSendTestDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "SendTest", data);
  }

  public getDefaultValues(): Observable<any[]> {
    return this.http.get<any[]>(this.pathAPI + this.controller + "GetDefaultValues");
  }

  public SendMailNewOrderDistributor(idOrder: string,): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "SendMailNewOrderDistributor/" + idOrder, null);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public changeDesiredDate(id: string, date: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeDesiredDate/' + id + '/' + date, null);
  }

  public getCampaignOrderListCampaign(idCampaignMedia: number): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaignOrderListCampaign/' + idCampaignMedia);
  }

  public getCampaignOrderList(data: RenaultPuntoapuntoLocalCampaignOrderListFilterDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "GetCampaignOrderList", data);
  }

  downloadExcelLocalCampaignEmailOrderStatistics(filters: RenaultPuntoapuntoLocalCampaignOrderListFilterDTO): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignEmailOrderStatisticsExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  public getLocalCampaignOrderStatistics(idOrders: number[]): Observable<PuntoapuntoLocalCampaignOrderDataStatisticsModel> {
    return this.http.post<PuntoapuntoLocalCampaignOrderDataStatisticsModel>(this.pathAPI + this.controller + 'GetLocalCampaignOrderStatistics/', idOrders);
  }

  public changeStatusOrderValidation(id: string, idStatus: number, declinedReason: string = null): Observable<any> {

    if (declinedReason)
      return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatusOrderValidation/' + id + '/' + idStatus + '?declinedReason=' + declinedReason, null);
    else
      return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatusOrderValidation/' + id + '/' + idStatus, null);
  }

  public getDatatableOrderValidation(data: any, filter): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDatatableOrderValidation/' + filter, data);
  }

  public GetOrderContactCount(id: string): Observable<number> {
    return this.http.get<number>(this.pathAPI + this.controller + 'GetOrderContactCount/' + id);
  }

  public GetOrderSentCount(id: string): Observable<number> {
    return this.http.get<number>(this.pathAPI + this.controller + 'GetOrderSentCount/' + id);
  }

  public GetOrderProcessCount(id: string): Observable<number> {
    return this.http.get<number>(this.pathAPI + this.controller + 'GetOrderProcessCount/' + id);
  }

  public GetLocalCampaignEmailStatistics(filters: LocalCampaignMediaStatisticsFilters): Observable<PuntoapuntoLocalCampaignEmailStatisticsModel> {
    return this.http.post<PuntoapuntoLocalCampaignEmailStatisticsModel>(this.pathAPI + this.controller + 'GetLocalCampaignEmailStatistics/', filters);
  }

  public GetLocalCampaignEmailStatisticsTable(filters: LocalCampaignMediaStatisticsFilters): Observable<PuntoapuntoLocalCampaignEmailStatisticsTable[]> {
    return this.http.post<PuntoapuntoLocalCampaignEmailStatisticsTable[]>(this.pathAPI + this.controller + 'GetLocalCampaignEmailStatisticsTable/', filters);
  }

  public GetLocalCampaignEmailStatisticsSelectCampaign(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetLocalCampaignEmailStatisticsSelectCampaign');
  }

  public getLocalCampaignOrderStatisticsTimechart(idOrders: number[]): Observable<PuntoapuntoLocalCampaignOrderDataStatisticsTimechartModel[]> {
    return this.http.post<PuntoapuntoLocalCampaignOrderDataStatisticsTimechartModel[]>(this.pathAPI + this.controller + 'GetLocalCampaignOrderStatisticsTimechart/', idOrders);
  }

  public getCampaignOrderDetailStatistics(idOrder: string): Observable<RenaultPuntoapuntoLocalCampaignOrderStatisticsDTO> {
    return this.http.get<RenaultPuntoapuntoLocalCampaignOrderStatisticsDTO>(this.pathAPI + this.controller + 'GetCampaignOrderDetailStatistics/' + idOrder);
  }

  getLocalCampaignOrderDataStatisticsExcelMail(idOrder: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignOrderDataStatisticsExcelMail/' + idOrder;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  downloadExcelLocalCampaignEmailStatistics(filters: LocalCampaignMediaStatisticsFilters): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLocalCampaignEmailStatisticsExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  generarPDF(htmlOutputString: string, campaignTitle: string, activeModal: NgbActiveModal = null) {


    const contenedorMedicion = document.createElement('div');
    contenedorMedicion.style.position = 'absolute';
    contenedorMedicion.style.visibility = 'hidden';
    contenedorMedicion.style.width = 'fit-content';
    contenedorMedicion.style.height = 'auto';
    contenedorMedicion.innerHTML = htmlOutputString;
    document.body.appendChild(contenedorMedicion);

    Swal.fire({
      icon: 'info',
      title: 'Generando PDF',
      text: 'Espere por favor...'
    });
    Swal.showLoading();

    setTimeout(() => {

      try {

        const anchoContenido = contenedorMedicion.offsetWidth;
        const alturaContenido = contenedorMedicion.scrollHeight;

        document.body.removeChild(contenedorMedicion);

        const pixelesAMM = 3.7795275591;
        const anchoEnMM = (anchoContenido / pixelesAMM).toFixed(2);
        const alturaEnMM = (alturaContenido / pixelesAMM).toFixed(2);

        // Generar PDF
        (html2pdf as any)()
          .from(htmlOutputString)
          .set({
            html2canvas: {
              useCORS: true,
              logging: true,
              allowTaint: true,
              scale: 2,
            },
            jsPDF: {
              unit: 'mm',
              format: [
                parseFloat(anchoEnMM) + 50, // Añadir 50mm de ancho extra
                parseFloat(alturaEnMM)
              ],
              orientation: 'portrait',
              margin: [0, 0, 0, 0],
              compress: true,
            }
          })
          .toPdf()
          .get('pdf')
          .then((pdf) => {

            //A veces según el tamaño del html, genera una segunda página en blanco.
            //Hay que recorrer todas la páginas y eliminar todas las que no sean la primera.

            // Obtener el número total de páginas generadas
            const totalPages = pdf.internal.pages.length;

            // Eliminar todas las páginas excepto la primera
            for (let i = totalPages; i > 1; i--) {
              pdf.deletePage(i); // Eliminar cada página a partir de la segunda
            }

            // Guardar el PDF
            pdf.save(campaignTitle);

            Swal.close();
            if (activeModal) activeModal.dismiss();
          })
          .catch((error) => {
            console.error('Error generando PDF:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudo generar el PDF',
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-outline-secondary'
              },
              confirmButtonText: 'Cerrar'
            });
          });

      } catch (error) {
        console.error('Error de medición:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error de medición',
          text: 'No se pudo medir el contenido',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-outline-secondary'
          },
          confirmButtonText: 'Cerrar'
        });
      }
    }, 200);

  }

}
